import React, { Component } from "react";
import { Button } from "react-bootstrap";
import WidgetPageRenderer from "../WidgetPageRenderer";

/**
 * LayoutPreview - Live preview of a page layout using WidgetPageRenderer.
 * Uses a fullscreen overlay instead of a Modal to avoid z-index conflicts
 * with Offcanvas forms inside rendered widgets.
 *
 * Props:
 *   - pageRoute: The route to preview
 *   - show: Whether the preview is visible
 *   - onClose: Callback to close the preview
 */
export default class LayoutPreview extends Component {
  render() {
    const { pageRoute, show, onClose } = this.props;

    if (!show) return null;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1040,
          backgroundColor: "#f5f5f5",
          overflowY: "auto",
        }}
      >
        {/* Header Bar */}
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1041,
            backgroundColor: "#fff",
            borderBottom: "1px solid #dee2e6",
            padding: "8px 16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <span style={{ fontSize: "1rem", fontWeight: 600 }}>
            <i className="bi bi-eye me-2"></i>
            Layout Preview: {pageRoute}
          </span>
          <Button variant="secondary" size="sm" onClick={onClose}>
            <i className="bi bi-x-lg me-1"></i>
            Close Preview
          </Button>
        </div>

        {/* Page Content */}
        <div style={{ padding: "16px" }}>
          {pageRoute ? (
            <WidgetPageRenderer pageRoute={pageRoute} />
          ) : (
            <div className="text-center text-muted py-5">
              No page route specified for preview.
            </div>
          )}
        </div>
      </div>
    );
  }
}
